import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { OptionsCheckbox } from 'owa-options-controls';
import controlStrings from 'owa-strings/owa-common-strings';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
var styles = require('./InboxRuleRetryDialog.scss');
var InboxRuleRetryDialog = /** @class */ (function () {
    function InboxRuleRetryDialog(subtext, onConfirm, onDismiss) {
        var _this = this;
        this.subtext = subtext;
        this.isChecked = false;
        this.onConfirm = onConfirm;
        this.onDismiss = onDismiss;
        this.dialogOptions = {
            okText: controlStrings.okButton,
            cancelText: controlStrings.cancelButton,
            bodyElement: (React.createElement(OptionsCheckbox, { label: strings.options_inboxRules_dontShowMessageAgain, onChange: function () {
                    _this.isChecked = !_this.isChecked;
                } })),
            containerClassName: styles.dialogContainer,
        };
    }
    InboxRuleRetryDialog.prototype.show = function () {
        var _this = this;
        return confirm('Warning', this.subtext, false, this.dialogOptions).then(function (response) {
            if (response === DialogResponse.ok) {
                return _this.onConfirm(_this.isChecked);
            }
            else {
                return _this.onDismiss();
            }
        });
    };
    return InboxRuleRetryDialog;
}());
export default InboxRuleRetryDialog;
//# sourceMappingURL=InboxRuleRetryDialog.js.map